import { customerPanelUIUrl, franchiseUIUrl, kioskUIUrl, reservationUIUrl, terminalsUIUrl } from '../../../../../urls'
import { isLocalStorageMobileAppMode, MOBILE_APP_MODE } from '../../../../../helper/mode'
import { getLocalStorageLanguage } from '../../../../../helper'
import { logger } from '../../../../../logger/logger'
import { staticPages } from '@liefersoft/pos-ui-core'
import { getPagesFromRoles } from '../../../page/helper'
import { isPayTerminalOnly, isReservationOnly } from '../../../../../helper/capabilities'

export const redirectToLogin = () => {
	if (window.location.pathname === '/help') {
		window.location.href = '/login'
	}
}

export const getAppModeParam = (isFirstParam = true) => {
	const isMobileApp = isLocalStorageMobileAppMode()
	if (!isMobileApp) return ''
	const separator = isFirstParam ? '?' : '&'
	return `${separator}appMode=${MOBILE_APP_MODE}`
}

const EXTERNAL_PAGE_IDS = ['BACKOFFICE', 'RESERVATION']

const cashDeskPages = staticPages.filter(p => !EXTERNAL_PAGE_IDS.includes(p.id))

const getDefaultUrl = (accessToken) => {
	const pages = getPagesFromRoles(accessToken)
	const firstPage = cashDeskPages.find(p => pages.includes(p.id))
	return firstPage?.link || cashDeskPages[0].link
}

export const redirectByUserType = ({ user, accessToken, refreshToken }) => {
	const userGroup = user?.group
	const franchise = user?.company?.franchiseMetaData
	const payTerminalOnly = isPayTerminalOnly(user)
	const reservationOnly = isReservationOnly(user)
	const language = getLocalStorageLanguage()

	let url
	if (userGroup === 'KIOSK') {
		url = kioskUIUrl + `?accessToken=${accessToken}&refreshToken=${refreshToken}${getAppModeParam(false)}`
	} else if (franchise?.type === 'FRANCHISE' && accessToken && refreshToken) {
		url = franchiseUIUrl + `/${language}/franchise-portal${getAppModeParam()}`
	} else if (payTerminalOnly && accessToken && refreshToken) {
		url = terminalsUIUrl + `/${language}${getAppModeParam()}`
	} else if (reservationOnly && accessToken && refreshToken) {
		url = reservationUIUrl + `/${language}${getAppModeParam()}`
	} else if (userGroup === 'KIOSK_ADMIN' && accessToken && refreshToken) {
		url = customerPanelUIUrl + `/${language}/customerPanel?accessToken=${accessToken}&refreshToken=${refreshToken}${getAppModeParam(false)}`
	} else {
		url = getDefaultUrl(accessToken) + getAppModeParam()
	}

	logger.info('Redirect to: ', url)
	setTimeout(() => {
		window.location.href = url
	}, 500)
}

